import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';

// material
import { alpha, styled } from '@mui/material/styles';
import { Box, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
// hooks
import useLocales from '../../hooks/useLocales';
// components
import MenuPopover from '../../components/MenuPopover';
import { MIconButton } from '../../components/@material-extend';

const LightTooltip = styled(
  ({
    title,
    children,
    className,
    ...props
  }: React.ComponentProps<typeof Tooltip> & { title: string }) => (
    <Tooltip {...props} title={title} classes={{ popper: className }}>
      {children}
    </Tooltip>
  )
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11
  }
}));

// ----------------------------------------------------------------------

export default function LanguagePopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { trans, currentLang, onChangeLang } = useLocales();
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeLang = (value: string) => {
    onChangeLang(value);
    handleClose();
    window.location.reload();
  };

  const LANGS = [
    {
      label: '繁體中文',
      value: 'zh'
    },
    {
      label: '简体中文',
      value: 'cn'
    },
    {
      label: 'English',
      value: 'english'
    }
  ];

  return (
    <>
      <LightTooltip title={trans('ModifySecret.switch_language')}>
        <MIconButton
          ref={anchorRef}
          onClick={handleOpen}
          sx={{
            padding: 0,
            width: 44,
            height: 44,
            ...(open && {
              bgcolor: (theme) =>
                alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
            })
          }}
        >
          <Box
            component={Icon}
            icon="material-symbols:language"
            sx={{
              width: 30,
              height: 30
            }}
          />
        </MIconButton>
      </LightTooltip>

      <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current} sx={{ py: 1 }}>
        {LANGS.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === currentLang.value}
            onClick={() => handleChangeLang(option.value)}
            sx={{ py: 1, px: 2.5 }}
          >
            <ListItemText primaryTypographyProps={{ variant: 'body2' }}>
              {option.label}
            </ListItemText>
          </MenuItem>
        ))}
      </MenuPopover>
    </>
  );
}
